import { hydrateUiRentalTicketState, initiateRental, rentalTicketState } from './rentalTicket';

// the following is imported in actions/index.js as "rentalTicket"
export default {
  hydrateUiRentalTicketState,
  initiateRental,
  rentalTicketState
};
